"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Toggle_1 = require("./Toggle");
exports.default = Toggle_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Toggle/index.js
// module id = 1826
// module chunks = 8